<mat-drawer-container>
  <mat-drawer-content>
    <div class="exports-content" fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="column">
          <h1 class="report-header">Exports</h1>
        </div>
      </div>

      <search-bar
        [placeholder]="'Find file...'"
        [iconDirection]="'right'"
        (onChange)="searchExports($event)"
      ></search-bar>

      <div *ngIf="isFetchingData" class="waiting-spinner">
        <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
        <p>Loading...</p>
      </div>

      <ng-scrollbar [track]="'all'">
        <mat-table #table [dataSource]="dataSource" *ngIf="this.dataSource.data.length && !isFetchingData">
          <ng-container matColumnDef="filename">
            <mat-header-cell *matHeaderCellDef> File Name </mat-header-cell>
            <mat-cell *matCellDef="let element"
              ><a (click)="getS3Object(element.key)"> {{ element.filename }} </a></mat-cell
            >
          </ng-container>

          <ng-container matColumnDef="lastModified">
            <mat-header-cell *matHeaderCellDef> Uploaded on </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.lastModified | localDate }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="expiresIn">
            <mat-header-cell *matHeaderCellDef> Expires In </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              [ngClass]="{
                'font-red': this.expiresInFromLastModify(element.lastModified, 14, 'days').indexOf('day') === -1
              }"
            >
              {{ element.lastModified | expiresIn: 14:'days' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a (click)="getS3Object(element.key)"
                ><mat-icon aria-hidden="false" aria-label="Download">download</mat-icon></a
              >
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </ng-scrollbar>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
